interface ParsedContentDisposition {
    type: string;
    fileName?: string;
    fileNameStar?: string;
}

export function parseContentDisposition(header: string, keyName: string): ParsedContentDisposition {
    if (!header) {
        throw new Error('Header string is empty');
    }

    const result: ParsedContentDisposition = { type: '' };
    const parts = header.split(';').map(part => part.trim());

    // First part is the disposition type
    result.type = parts[0].toLowerCase();

    for (let i = 1; i < parts.length; i++) {
        const part = parts[i];
        const split = part.split('=');
        const key = split[0].trim().toLowerCase();
        let value = split.slice(1).join('=').trim();

        // Remove quotes if present
        if (value.startsWith('"') && value.endsWith('"')) {
            value = value.slice(1, -1);
        }

        if (key === keyName) {
            result.fileName = value;
        } else if (key === 'filename*') {
            // Handle RFC 5987 encoded filename (UTF-8)
            const encodingEnd = value.indexOf("''");
            if (encodingEnd !== -1) {
                value = decodeURIComponent(value.substring(encodingEnd + 2));
            }
            result.fileNameStar = value;
        }
    }

    return result;
}
